<template>
  <div class="p-3">
    <p>
      <strong>Filter by</strong>
      <a
        class="float-right"
        tabindex="0"
        aria-label="click to clear search filters"
        @click.prevent="clearFilters"
      >Clear filters</a>
    </p>

    <div
      id="age-range"
      class="mb-3 border-bottom "
    >
      <div>
        <span class="sr-only"> age range </span>
        <span>Age range</span>
      </div>
      <div>
        <b-row>
          <b-col cols="6">
            <span>from:</span>
            <b-form-input
              v-model.trim.lazy="filters.minimum_age"
              :disabled="formLock"
              placeholder="Min"
            />
          </b-col>
          <b-col cols="6">
            <span>to:</span>
            <b-form-input
              v-model.trim.lazy="filters.maximum_age"
              :disabled="formLock"
              placeholder="Max"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <div
      id="price"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Maximum price</span>
      </div>

      <div>
        <b-input-group
          prepend="
      £"
        >
          <b-form-input
            v-model.trim.lazy="filters.maximum_price"
            :disabled="formLock"
            placeholder="Max"
          />
        </b-input-group>
      </div>
    </div>
    
    <div
      id="categories"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Categories</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.activity_categories"
          :options="activityCategories"
          value-field="id"
          text-field="name"
          name="activity_categories[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="booking-type"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Booking type</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.booking_options"
          :options="bookingOptions"
          value-field="id"
          text-field="text"
          name="booking_options[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="meals"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Meals</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.meals"
          :options="meals"
          value-field="id"
          text-field="name"
          name="meals[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="added-extras"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Added extras</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.provisions"
          :options="provisions"
          value-field="id"
          text-field="name"
          name="provisions[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="accepted-payment-methods "
      class="mb-3 border-bottom "
    >
      <div>
        <span>Accepted payment methods</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.payment_types"
          :options="paymentTypes"
          value-field="id"
          text-field="name"
          name="payment_types[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="provision-terms"
      class="mb-3  border-bottom "
    >
      <div>
        <span>Provision Terms</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.provision_terms"
          :options="provisionTerm"
          value-field="id"
          text-field="name"
          name="provision_terms[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>

    <div
      id="asn"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Additional Support Needs</span>
      </div>

      <div>
        <b-form-checkbox
          v-model="filters.specialises_asn"
          name="specialises_asn"
          :disabled="formLock"
        >
          Specialises in ASNs
        </b-form-checkbox>
      </div>
    </div>

    <div
      id="availability"
      class="mb-3 border-bottom "
    >
      <div>
        <span>Other Criteria</span>
      </div>

      <div>
        <b-form-checkbox-group
          v-model="filters.availability"
          :options="availabilities"
          value-field="id"
          text-field="name"
          name="availability[]"
          stacked
          :disabled="formLock"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {

  name: 'SearchFiltersMobile',

  components: {
  },

  props: {
    routeQuery: {
      type: Object,
      default: () => ({})
    }
  },

  data() {

    return {
    	formLock: false,
    	filters: {},
    }
  },

  created() {
    this.syncFiltersFromRoute(this.routeQuery)
  },

  computed: {
  	...mapGetters('core', [
  		'ageGroups',
  		'paymentTypes',
  		'activityCategories',
  		'bookingOptions',
  		'provisions',
			'provisionTerm',
  		'meals',
  		'availabilities',
		]),
  },

  watch: {
  	routeQuery: {
  		handler(query) {
  			this.syncFiltersFromRoute(query || {})
  		},
  		deep: true
  	},
  	filters: {
  		handler: _.debounce(function (val) {
  			this.$emit('filter', this.filters)
  		}, 1000),
  		deep: true,
  		immediate: false,

  	},
  },

 
  methods: {

  	getDefaultFilters() {
  		return {
  			minimum_age: null,
  			maximum_age: null,
  			minimum_price: null,
  			maximum_price: null,
  			activity_categories: [],
  			booking_options: [],
  			provisions: [],
  			payment_types: [],
  			provision_terms: [],
  			meals: [],
  			availability: [],
  			specialises_asn: null
  		}
  	},

  	syncFiltersFromRoute(query) {
  		const defaults = this.getDefaultFilters()
  		if (!query || Object.keys(query).length === 0) {
  			this.filters = { ...defaults }
  			return
  		}
  		const parsed = { ...defaults }
  		const arrayKeys = ['activity_categories', 'booking_options', 'provisions', 'payment_types', 'provision_terms', 'meals', 'availability']
  		arrayKeys.forEach(key => {
  			if (query[key] != null) {
  				parsed[key] = Array.isArray(query[key]) ? query[key] : [query[key]].filter(Boolean)
  			}
  		})
  		;['minimum_age', 'maximum_age', 'maximum_price'].forEach(key => {
  			if (query[key] != null && query[key] !== '') {
  				parsed[key] = query[key]
  			}
  		})
  		if (query.specialises_asn != null && query.specialises_asn !== '') {
  			parsed.specialises_asn = query.specialises_asn === true || query.specialises_asn === 'true'
  		}
  		this.filters = parsed
  	},

  	clearFilters() {
  		this.filters = { ...this.getDefaultFilters() }
  		this.$emit('filter', this.filters)
  		this.$emit('clear')
  	},

    filterSearch(){
      this.$emit(filter, this.filters)
    }

  },
}
</script>
<style>
.border-bottom {
	border-bottom: 1px solid rgba(29, 37, 45, 0.2);
	padding-bottom: 15px
}

</style>
